import { Fragment } from 'react';
import { calmTokens as t } from '../../shared/tokens';
import { MONTHS_FR } from '../../shared/locale';
import { fmtEUR } from '../../shared/format';
import { templateId } from '../../shared/recurrence';
import ForecastSageTxCard from './ForecastSageTxCard';

export default function ForecastSageDayGroup({
  day,
  month,
  txs,
  isDone,
  tense = 'future',
}) {
  const monthLabel = (MONTHS_FR[month] || '').toLowerCase();
  const total = txs.reduce((s, tx) => {
    const done = isDone(tx);
    if (done) return s;
    return s + (tx.type === 'credit' ? tx.amount : -tx.amount);
  }, 0);
  const positive = total >= 0;

  const tenseLabel =
    tense === 'past' ? 'passé' : tense === 'today' ? "aujourd'hui" : 'à venir';

  return (
    <div style={{ marginBottom: 14 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          padding: '18px 20px 8px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: t.text,
              letterSpacing: -0.1,
              fontFamily: t.fontUi,
            }}
          >
            {day} {monthLabel}
          </span>
          <span
            style={{
              fontSize: 11,
              color: tense === 'today' ? t.accent : t.textMute,
              fontFamily: t.fontUi,
              fontWeight: tense === 'today' ? 500 : 400,
            }}
          >
            {tenseLabel}
          </span>
        </div>
        {total !== 0 && (
          <span
            style={{
              fontFamily: t.fontMono,
              fontSize: 12,
              color: positive ? t.credit : t.debit,
              letterSpacing: -0.2,
              fontVariantNumeric: 'tabular-nums',
              opacity: 0.85,
            }}
          >
            {positive ? '+ ' : '− '}
            {fmtEUR(Math.abs(total))}
          </span>
        )}
      </div>

      <div
        style={{
          background: t.surface,
          border: `1px solid ${t.border}`,
          borderRadius: 16,
          overflow: 'hidden',
        }}
      >
        {txs.map((tpl, i) => (
          <Fragment key={templateId(tpl)}>
            {i > 0 && (
              <div
                style={{
                  height: 1,
                  background: t.border,
                  margin: '0 20px',
                }}
              />
            )}
            <ForecastSageTxCard tpl={tpl} done={isDone(tpl)} />
          </Fragment>
        ))}
      </div>
    </div>
  );
}
